import '/components/footer/footer.scss';
